import { Components, Theme } from '@mui/material';

export const buildMuiBreadcrumbsComponent = (): Components<Omit<Theme, 'components'>>['MuiBreadcrumbs'] => ({
  styleOverrides: {
    root: ({ theme }) => ({
      '& .MuiBreadcrumbs-ol': {
        '.MuiBreadcrumbs-li:last-of-type .MuiTypography-root': {
          color: theme.palette.primary[70],
        },
        '.MuiBreadcrumbs-li .MuiTypography-root, .MuiBreadcrumbs-li:first-of-type .MuiTypography-root': {
          color: theme.palette.primary.main,
        },
        'li > .MuiButtonBase-root': {
          backgroundColor: 'transparent',
          color: theme.palette.primary.main,
          '& svg': {
            height: '20px',
            marginTop: '6px',
          },
        },
        '.MuiBreadcrumbs-separator': {
          color: theme.palette.primary[80],
          fontSize: '16px',
          lineHeight: '150%',
        },
      },
    }),
  },
});
